export class SystemModel {
    _id: string;
    name: string;
    description: string;

    constructor(id = null,
        name = '',
        description = '') {
            this._id = id;
            this.name = name;
            this.description = description;
    }
}
